import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext, useState } from "react";
const EditContext = createContext(undefined);
export const EditProvider = ({ children }) => {
    const [editingSlideId, setEditingSlideId] = useState(null);
    const [editSlideTitle, setEditSlideTitle] = useState("");
    const [editSlidePurpose, setEditSlidePurpose] = useState("");
    const [addingAtPosition, setAddingAtPosition] = useState(null);
    const [newSlideTitle, setNewSlideTitle] = useState("");
    const [newSlidePurpose, setNewSlidePurpose] = useState("");
    const [addingSectionAfterIndex, setAddingSectionAfterIndex] = useState(null);
    const [creatingSectionAtIndex, setCreatingSectionAtIndex] = useState(null);
    const [newSectionDescription, setNewSectionDescription] = useState("");
    const startEditSlide = (slideId, currentTitle, currentPurpose) => {
        setEditingSlideId(slideId);
        setEditSlideTitle(currentTitle);
        setEditSlidePurpose(currentPurpose || "");
    };
    const cancelEditSlide = () => {
        setEditingSlideId(null);
        setEditSlideTitle("");
        setEditSlidePurpose("");
    };
    const startAddSlide = (sectionId, index) => {
        setAddingAtPosition({ sectionId, index });
        setNewSlideTitle("");
        setNewSlidePurpose("");
    };
    const cancelAddSlide = () => {
        setAddingAtPosition(null);
        setNewSlideTitle("");
        setNewSlidePurpose("");
    };
    const startAddSection = (afterIndex) => {
        setAddingSectionAfterIndex(afterIndex);
        setNewSectionDescription("");
    };
    const cancelAddSection = () => {
        setAddingSectionAfterIndex(null);
        setNewSectionDescription("");
        setCreatingSectionAtIndex(null);
    };
    const stopSectionCreation = () => {
        setCreatingSectionAtIndex(null);
        setAddingSectionAfterIndex(null);
        setNewSectionDescription("");
    };
    const value = {
        editingSlideId,
        editSlideTitle,
        editSlidePurpose,
        addingAtPosition,
        newSlideTitle,
        newSlidePurpose,
        addingSectionAfterIndex,
        creatingSectionAtIndex,
        newSectionDescription,
        setEditingSlideId,
        setEditSlideTitle,
        setEditSlidePurpose,
        setAddingAtPosition,
        setNewSlideTitle,
        setNewSlidePurpose,
        setAddingSectionAfterIndex,
        setCreatingSectionAtIndex,
        setNewSectionDescription,
        startEditSlide,
        cancelEditSlide,
        startAddSlide,
        cancelAddSlide,
        startAddSection,
        cancelAddSection,
        stopSectionCreation,
    };
    return _jsx(EditContext.Provider, { value: value, children: children });
};
export const useEdit = () => {
    const context = useContext(EditContext);
    if (!context) {
        throw new Error("useEdit must be used within an EditProvider");
    }
    return context;
};
